var React = require('react');

function MultipleSizes (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 0H51.42V16.9399H60.8399V34.1799H67.8601V67.9699H33.8501V60.5599H16.9399V50.99H0V0ZM16.9399 49.19V16.9399H49.62V1.8H1.8V49.19H16.9399ZM33.8501 58.7599V34.1799H59.0399V18.7399H18.7399V58.7599H33.8501ZM35.6501 35.9799V66.1699H66.0601V35.9799H35.6501Z","fill":"black"}));
}

MultipleSizes.defaultProps = {"width":"68","height":"68","viewBox":"0 0 68 68","fill":"none"};

module.exports = MultipleSizes;

MultipleSizes.default = MultipleSizes;
